import type * as Api from 'Api'

export const announcementErrorMessages: Dictionary<Dictionary<string>> = {
  lastName: {
    default: 'Допущена ошибка в фамилии',
    required: 'Введите фамилию',
  },
  firstName: {
    default: 'Допущена ошибка в имени',
    required: 'Введите имя',
  },
  email: {
    default: 'Допущена ошибка в электронной почте',
    required: 'Введите свою электронную почту',
    email: 'Электронная почта введена неверно',
  },
  phoneNumber: {
    default: 'Допущена ошибка в номере телефона',
    required: 'Введите номер телефона',
    phone: 'Телефон должен быть указан в формате ',
  },
  captcha: {
    default: 'Обнаружена подозрительная активность',
  },
  notAnnouncement: {
    default: 'На это событие нельзя оставить заявку',
  },
}
export const announcementErrorHandbook: Api.ErrorsHandbook<
  'default' | 'announcement'
> = {
  default: [],
  announcement: [
    {
      status: 1,
      code: 404,
      message: announcementErrorMessages.notAnnouncement.default,
    },
  ],
}
